import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import OnBoardingNotificationSettingsModal from './OnBoardingNotificationSettingsModal'
import { getTimePreferences } from 'store/entities/identity/selectors'
import { onBoarding } from 'store/entities/onBoarding/actions'

const mapStateToProps = createStructuredSelector({
  initialValues: getTimePreferences,
})

const mapDispatchToProps = () => ({
  onSubmit: (values, dispatch) => {
    dispatch(onBoarding.savePreferences(values))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withTranslation('user')(OnBoardingNotificationSettingsModal)
)
